import useCourse from 'providers/Course/useCourse';

/**
 * Affiche le nom de la course courante (remplace l'ancien user.datasource).
 */
const CourseTitle = () => {
  const { selectedCourse } = useCourse();
  return <>{selectedCourse?.name ?? ''}</>;
};

export default CourseTitle;
